import React from 'react';

import Icon from '../Icon';
import { CheckCircleRounded, WatchLater, ErrorRounded, InfoRounded } from '@material-ui/icons';

import { StatusIconProps } from './StatusIcon.types';

const StatusIcon: React.FC<StatusIconProps> = ({
  variant,
  colorVariant,
  width,
  height,
  className
}) => {
  const props = {
    color: colorVariant || variant,
    width,
    height,
    className
  };

  if (variant === 'warning') {
    return <Icon icon={ErrorRounded} {...props} />;
  }

  if (variant === 'danger' || variant === 'failed' || variant === 'rejected') {
    props.color = colorVariant || 'danger';
    return <Icon icon={ErrorRounded} {...props} />;
  }

  if (variant === 'primary') {
    return <Icon icon={InfoRounded} {...props} />;
  }

  if (variant === 'pending') {
    props.color = colorVariant || 'warning';
    return <Icon icon={WatchLater} {...props} />;
  }

  if (variant === 'success') {
    return <Icon icon={CheckCircleRounded} {...props} />;
  }

  return <Icon icon={ErrorRounded} {...props} />;
};

StatusIcon.defaultProps = {
  variant: 'primary',
  width: 36,
  height: 36,
};

export default StatusIcon;
export { StatusIconProps };
